import { Box, BoxProps, packSx } from '@mantine/core';

type LayoutProps = BoxProps & {
  displayBar?: boolean;
};

/**
 * Layout component for the offers page
 * @private
 *
 * @param children - The children to render
 * @param displayBar - Whether to display the bar or not
 * @param sx - The style object
 * @param boxProps - Box props
 */
export const Layout: React.FC<LayoutProps> = ({
  children,
  displayBar = true,
  sx,
  ...boxProps
}) => (
  <Box
    sx={[
      theme => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        minHeight: '100vh',
        backgroundColor: theme.colors.violet[1],
        padding: '54px 0 24px 0',
        '&:before': displayBar
          ? {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 112,
              backgroundColor: theme.colors.violet[2],
              borderBottom: `1px solid ${theme.colors.violet[3]}`,
              zIndex: 0,
            }
          : undefined,
      }),
      ...packSx(sx),
    ]}
    {...boxProps}
  >
    {children}
  </Box>
);
